import { render, staticRenderFns } from "./UserQualificationAdd.vue?vue&type=template&id=0040e469&"
import script from "./UserQualificationAdd.vue?vue&type=script&lang=js&"
export * from "./UserQualificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports